// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ea6fa5da8--container--o326g","name":"_3ea6fa5da8--name--xlUVq","offer":"_3ea6fa5da8--offer--KgmQh","link":"_3ea6fa5da8--link--GSyFr"};